<span *ngIf="productGrade; else loading">
    {{ productGrade?.totaal }}
</span>

<ng-template #loading>...</ng-template>
